import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { GtagService } from 'src/app/services/gtag.service';
import { FbService } from 'src/app/services/fb.service';
import { ValidatorService } from 'src/app/services/validator.service';

@Component({
  selector: 'meus-servicos-page',
  templateUrl: './meus-servicos-page.component.html',
  styleUrls: ['./meus-servicos-page.component.scss']
})
export class MeusServicosPage implements OnInit {

  public loader   = false;
  private apelido = "consultar-reserva"; 
  public response:any = {
    data: "",
    status: null
  };
  public page     = null;
  public fotos    = []; 
  public params:any = {};
  public itensBreadcrumbs = [];
  public isSendAnalytics    = false;
  public dataItem:any  = {};
  public dataFile = {
    dados: null,
    pasageiros: [],
    servicos: []
  }

  constructor(
    private api:ApiService,
    private app: AppService,
    private validator: ValidatorService
  ) { }
  

  /**
   * 
   * Buscar
   * 
   */
  buscar(){

    try{

      this.validator.clear();
      this.validator.isEmpty(this.dataItem.file,"file","Informe o código da reserva (File).");
      this.validator.isEmpty(this.dataItem.sobrenome,"sobrenome","Informe o seu Sobrenome.");

      if(this.validator.passes()){

        this.loader = true;

        this.api.manage().consultarReserva({
          file: this.dataItem.file, 
          ultimonome: this.dataItem.sobrenome
        }).subscribe(response => {

          this.loader = false;

          if(response.status == 1){

            this.dataFile.dados = {
              file: response.data.idFile,
              cliente: response.data.Cliente,
              qtdPaxs: response.data.qtdPaxs,
              titular: response.data.paxTitular,
              dataInicio: response.data.dataInicioServicos,
              dataFim: response.data.dataFimServicos,
              cidade: response.data.cidadeFile,
              hotel: response.data.nomeHotelFile,
              status: response.data.statusFile
            }
            if(typeof(response.data.programacaoFile.Servico) != "undefined"){

              this.dataFile.servicos = typeof(response.data.programacaoFile.Servico[0]) == "undefined" ? [response.data.programacaoFile.Servico] : response.data.programacaoFile.Servico; 

            }

          }else{

            this.app.info(response.data,"danger"); 

          }


        },(response) => {

          this.loader = false;

        });

      }else{

        let error = this.validator.getMessagesHtml();
        this.app.info(error,"danger"); 

      }

    }catch(e){



    }


  }
  /**
   * 
   * 
   * 
   * 
   */
  getData(){

    try{
      
      this.loader = true; 
      
      this.api.conteudo().page(this.apelido).subscribe(response => {
      
        this.loader = false;
      
        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
                  
            this.page      = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params    = JSON.parse(this.page.params);
            this.app.setMetaDados(this.page.meta_title,this.page.meta_description);
            this.app.toTop();
          }
          this.response = { 
            data: "",
            status: 1
          }
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500
          }
        }
      
      },(err) =>{
      
        this.loader = false;
        this.response = err;
      
      });
    
    }catch(e){
      
    }

  }
  /**
   * 
   * Init data item
   * 
   */
  initDataItem(){

    this.dataItem = {
      file: "",
      sobrenome: ""
    }

  }
  /***
   * 
   * Seta os breadcrumbs
   * 
   */
  setItensBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Meus Serviços"
    });

  }
  /**
   * 
   * Formata passageiros
   * 
   */
  formatPassageiros(servico){

    let data = [];

    if(typeof(servico.paxsServicos.paxServico) !== "undefined"){

      data = typeof(servico.paxsServicos.paxServico[0]) == "undefined" ? [servico.paxsServicos.paxServico] : servico.paxsServicos.paxServico;

    } 

    return data;

  }
  /**
   * 
   * Serviço
   * 
   */
  verPassageiros(servico){ 

    servico.ver_passageiro = servico.ver_passageiro ? false : true;
   
  }
   /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){
    this.app.toTop();
    this.getData(); 
    this.setItensBreadcrumbs();
    this.initDataItem();
  }
  ngAfterViewInit(): void {
    
  }
  ngOnDestroy(): void {

  }

}
